import "./App.css";
import Drawing from "./Components/Drawing";
import Nav from "./Components/Nav";
import About from "./Components/About";
import {useLocation, Route, Routes,} from "react-router-dom";
import Projects from "./Components/Projects";
import Contact from "./Components/Contact"
import Home from "./Components/Home"
import {AnimatePresence} from 'framer-motion'
import {useState} from 'react'

function App(){
    const [previewGif, setPreviewGif] = useState(true);
    const [previewHover, setPreviewHover] = useState(true);
    const location = useLocation();

    return(
        <div className="App">
            <Nav/>
            <AnimatePresence mode="wait">
                <Routes location={location} key={location.pathname}>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/about" element={<About/>}/>
                    <Route path="/projects" element={<Projects
                        previewGif={previewGif}
                        setPreviewGif={setPreviewGif}
                        previewHover={previewHover}
                        setPreviewHover={setPreviewHover}
                    />}/>
                    <Route path="/drawings" element={<Drawing/>}/>
                    <Route path="/contact" element={<Contact/>}/>
                </Routes>
            </AnimatePresence>
        </div>
    )
}

export default App;